export enum AssetCodeLength {
  XS = 10,
  S = 16,
  M = 20,
  L = 24,
  XL = 30,
  XXL = 40,
  XXXL = 45,
}
